import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Banner() {
  return (
    <section className="banner_parcheesi">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="banner_logo">
              <StaticImage
                src="../../../images/case-studies/parcheesi/logo.webp"
                alt="TekRevol"
                className="logo_amj"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={334}
                height={152}
              />
            </div>
            <p>
              Parcheesi Cash is an online multiplayer Spanish board game that is
              a recreation of the Parcheesi – the national game of India since
              medieval times. It’s an interactive game where users can team up
              with friends or family or compete against the AI.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/parcheesi-cash/id1604187763">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
              <Link to="https://play.google.com/store/apps/details?id=com.nextgentechusa.parcheesicash">
                <StaticImage
                  src="../../../images/case-studies/amj/google_play.webp"
                  alt="TekRevol"
                  className="btn_amj "
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/parcheesi/banner-main.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={544}
                height={479}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
